import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import StaffSelector from '../../../../StaffSelector'

const ClinicalLead = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <StaffSelector
        value={opsPlan?.clinicalLead ?? null}
        onChange={(e, value) => {
          setOpsPlan((prev) => ({
            ...prev,
            clinicalLead: value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        shrinkLabel={!!opsPlan?.clinicalLead}
        label="Clinical Lead"
      />
    </Grid>
  )
}

export default React.memo(ClinicalLead)
